import ScholarshipsContent from "$lib/data/generated/content/scholarships/data.json";

import { uploads as ScholarshipsUploads } from "$lib/data/generated/uploads/scholarships/uploads";

const content = {
	["scholarships"]: ScholarshipsContent
};
const uploads = {
	...ScholarshipsUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
